import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Fab,
    TextField,
    Select,
    MenuItem,
    CircularProgress,
    FormControlLabel,
    Checkbox,
    Tooltip,
    IconButton,
} from '@material-ui/core/';
import Modal from '../../../components/Modal/modal';
import Grid from '@material-ui/core/Grid';
import MUIDataTable from 'mui-datatables';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import axios from '../../../axios-default';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import AddIcon from '@material-ui/icons/Add';
import { easySnackbar } from '../../../store/Noti/noti.actions';

const CustomToolbar = ({ onClick }) => (
    <React.Fragment>
        <Tooltip title={'custom icon'}>
            <IconButton onClick={onClick}>
                <AddIcon />
            </IconButton>
        </Tooltip>
    </React.Fragment>
);

class AddressList extends Component {
    columns = [
        {
            name: 'firstName',
            label: 'First Name',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'lastName',
            label: 'Last Name',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'country',
            label: 'Country',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'stateProvince',
            label: 'State/Province',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'city',
            label: 'City',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'postcode',
            label: 'Post Code',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'phoneNo',
            label: 'Phone No',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'faxNo',
            label: 'Fax No',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'address_1',
            label: 'Address 1',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'codetype',
            label: 'Code Type',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'code',
            label: 'Code',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'defaultFlag',
            label: 'Default',
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                margin: '0px 4px',
                                width: 40,
                                height: 40,
                            }}
                        >
                            {value ? <CheckIcon /> : <CloseIcon />}
                        </div>
                    );
                },
            },
        },
        {
            name: 'id',
            label: 'Action',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div style={{ display: 'flex' }}>
                            <Fab
                                size="small"
                                aria-label="add"
                                style={{
                                    backgroundColor: '#75a0de',
                                    color: 'white',
                                    margin: '0px 4px',
                                }}
                                onClick={() => {
                                    this.setState({
                                        updatedAddress: Object.assign({}, value),
                                        editModalOpen: true,
                                    });
                                }}
                            >
                                <EditIcon />
                            </Fab>
                            <Fab
                                size="small"
                                aria-label="add"
                                style={{
                                    backgroundColor: '#da5851',
                                    color: 'white',
                                    margin: '0px 4px',
                                }}
                                onClick={async () => {
                                    if (window.confirm('Are you going to delete this address?')) {
                                        try {
                                            const { data } = await axios.delete(
                                                `case/address/${value.delivery_address_id}`
                                            );
                                            if (data.success) {
                                                this.setState(
                                                    {
                                                        loading: true,
                                                    },
                                                    () => this.componentDidMount()
                                                );
                                            } else {
                                                console.error(data.message);
                                            }
                                        } catch (err) {
                                            console.error(err);
                                            if (err.response && err.response.statusText === 'Unauthorized') {
                                                localStorage.removeItem('auth-token');
                                                localStorage.removeItem('expirationDate');
                                                localStorage.removeItem('role');
                                                this.props.history.push('/login');
                                            }
                                        }
                                    }
                                }}
                            >
                                <DeleteOutlineIcon />
                            </Fab>
                        </div>
                    );
                },
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.match.params.id,
            editModalOpen: false,
            modalError: '',
            updatedAddress: {},
            loading: true,
            countries: this.props.res.countries || [],
            stateProvincesList: this.props.res.stateProvincesList || [],
        };
    }

    async getStateProvinceList(stateProvinces = []) {
        if (!stateProvinces.length) {
            const stateProvinceRes = await axios.get(`res/state_province`);
            if (stateProvinceRes.data.success) return stateProvinceRes.data.state_province;
        }
        return stateProvinces;
    }

    async getCountryList(countries = []) {
        if (!countries.length) {
            const countryRes = await axios.get(`res/country`);
            if (countryRes.data.success) return countryRes.data.country;
        }
        return countries;
    }

    async componentDidMount() {
        try {
            const { data } = await axios.get(`case/address?user_id=${this.state.userId}`);
            console.log(data);
            let stateProvincesList =
                Array.isArray(this.props.res.stateProvincesList) && this.props.res.stateProvincesList.length > 0
                    ? this.props.res.stateProvincesList
                    : [];
            let countries =
                Array.isArray(this.props.res.countries) && this.props.res.countries.length > 0
                    ? this.props.res.countries
                    : [];
            stateProvincesList = await this.getStateProvinceList(stateProvincesList);
            countries = await this.getCountryList(countries);

            this.setState({
                address: data.address
                    .sort((a, b) => a.delivery_address_id - b.delivery_address_id)
                    .map((address) => ({
                        firstName: address.first_name,
                        lastName: address.last_name,
                        country: countries.find((c) => c.country_id === address.country_id)?.country_name || '',
                        stateProvince:
                            stateProvincesList.find((s) => s.state_province_id === address.state_province_id)?.name ||
                            '',
                        city: address.city,
                        postcode: address.postcode,
                        phoneNo: address.phone_no,
                        faxNo: address.fax_no,
                        address_1: address.address_1,
                        address_2: address.address_2,
                        defaultFlag: address.default_flag,
                        id: address,
                        codetype: address.address_code_type,
                        code: address.address_code,
                        countries,
                        stateProvincesList,
                    })),

                loading: false,
            });
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                this.props.history.push('/login');
            }
        }
    }

    handleAddressUpdate = async () => {
        try {
            const { data } = await axios.post(`case/address`, this.state.updatedAddress);
            if (data.success) {
                await this.props.showSnackbar('Address inserted', 'success');
                this.setState({
                    updatedAddress: {},
                    editModalOpen: false,
                });
                this.componentDidMount();
            }
        } catch (err) {
            console.error(err);
            if (err.response?.data?.invalid) {
                this.setState({
                    modalError: `Please enter ${err.response.data.invalid.join(',')}`,
                });
            } else if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                this.props.history.push('/login');
            } else {
                this.setState({
                    modalError: err.response.data.message,
                });
            }
        }
    };

    handleUpdate =
        (field, convertFunc) =>
        ({ target }) => {
            this.setState(({ updatedAddress }) => ({
                updatedAddress: {
                    ...updatedAddress,
                    [field]: convertFunc ? convertFunc(target) : target.value,
                },
            }));
            if (field === 'address_code_type') {
                this.setState(({ updatedAddress }) => ({
                    updatedAddress: {
                        ...updatedAddress,
                        ['address_code_type']: target.value === '0' ? 'LIMS' : '',
                    },
                }));
            }
            // reset state_province_id if country_id is changed
            if (field === 'country_id') {
                this.setState(({ updatedAddress }) => ({
                    updatedAddress: {
                        ...updatedAddress,
                        ['state_province_id']: null,
                    },
                }));
            }
        };

    returnCountry = () => {
        return this.state.countries.map((c) => (
            <MenuItem value={c.country_id} key={c.country_id}>
                {c.country_name}
            </MenuItem>
        ));
    };

    returnTypeCode = () => {
        return Object.entries({
            0: { typecode: 'LIMS' },
            // Add more objects as needed
        }).map(([id, s]) => (
            <MenuItem value={id} key={id}>
                {s.typecode}
            </MenuItem>
        ));
    };

    returnStateProvince = () => {
        return this.state.stateProvincesList
            .filter((s) => s.country_id === this.state.updatedAddress.country_id)
            .map((s) => (
                <MenuItem value={s.state_province_id} key={s.state_province_id}>
                    {s.name}
                </MenuItem>
            ));
    };

    addAddress = () => {
        this.setState({
            updatedAddress: {
                user_id: parseInt(this.props.match.params.id),
            },
            editModalOpen: true,
        });
    };

    render() {
        const options = {
            download: false,
            filterType: 'dropdown',
            responsive: 'scroll',
            selectableRows: false,
            rowsPerPage: 30,
            rowsPerPageOptions: [15, 30, 50],
            customToolbar: () => <CustomToolbar onClick={this.addAddress} />,
        };
        return (
            <div>
                {this.state.loading ? (
                    <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress style={{ color: 'rgb(6,26,46)' }} />
                    </Grid>
                ) : (
                    <>
                        {console.log('this.state.updatedAddress')}
                        {console.log(this.state.updatedAddress)}
                        <MUIDataTable
                            title={'Address List'}
                            data={this.state.address}
                            columns={this.columns}
                            options={options}
                        />
                        <Modal
                            className="modal"
                            modal="Address"
                            title={this.state.updatedAddress.delivery_address_id ? 'Modify Address' : 'Insert Address'}
                            open={this.state.editModalOpen}
                            handleClose={() => this.setState({ editModalOpen: false })}
                            handleDataSave={() => this.handleAddressUpdate()}
                            modalError={this.state.modalError}
                            submitButton={true}
                        >
                            <Grid item xs={12} style={{ padding: 4 }}>
                                <TextField
                                    id="first_name"
                                    label="First Name"
                                    margin="normal"
                                    style={{ width: '100%' }}
                                    value={this.state.updatedAddress.first_name}
                                    onChange={this.handleUpdate('first_name')}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ padding: 4 }}>
                                <TextField
                                    id="last_name"
                                    label="Last Name"
                                    style={{ width: '100%' }}
                                    margin="normal"
                                    value={this.state.updatedAddress.last_name}
                                    onChange={this.handleUpdate('last_name')}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ padding: 4 }}>
                                <p>Select country</p>
                                <Select
                                    onChange={this.handleUpdate('country_id')}
                                    style={{ width: '100%' }}
                                    value={this.state.updatedAddress.country_id}
                                >
                                    {this.returnCountry()}
                                </Select>
                            </Grid>

                            {Object.values(this.props.res.stateProvinces).some(
                                (s) => s.country_id == this.state.updatedAddress.country_id
                            ) ? (
                                <Grid item xs={12} style={{ padding: 4 }}>
                                    <p>Select State</p>
                                    <Select
                                        onChange={this.handleUpdate('state_province_id')}
                                        style={{ width: '100%' }}
                                        value={this.state.updatedAddress.state_province_id}
                                    >
                                        {this.returnStateProvince()}
                                    </Select>
                                </Grid>
                            ) : null}

                            <Grid item xs={12} style={{ padding: 4 }}>
                                <TextField
                                    id="city"
                                    label="City"
                                    margin="normal"
                                    style={{ width: '100%' }}
                                    value={this.state.updatedAddress.city}
                                    onChange={this.handleUpdate('city')}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ padding: 4 }}>
                                <TextField
                                    id="address_1"
                                    label="Address"
                                    margin="normal"
                                    style={{ width: '100%' }}
                                    onChange={this.handleUpdate('address_1')}
                                    value={this.state.updatedAddress.address_1}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ padding: 4 }}>
                                <TextField
                                    id="postcode"
                                    label="Zip/Postal Code"
                                    margin="normal"
                                    style={{ width: '100%' }}
                                    value={this.state.updatedAddress.postcode}
                                    onChange={this.handleUpdate('postcode')}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ padding: 4 }}>
                                <TextField
                                    id="phone_no"
                                    label="Phone Number"
                                    margin="normal"
                                    style={{ width: '100%' }}
                                    value={this.state.updatedAddress.phone_no}
                                    onChange={this.handleUpdate('phone_no')}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ padding: 4 }}>
                                <TextField
                                    id="fax_no"
                                    label="Fax Number"
                                    margin="normal"
                                    style={{ width: '100%' }}
                                    value={this.state.updatedAddress.fax_no}
                                    onChange={this.handleUpdate('fax_no')}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ padding: 4 }}>
                                <p>Code Type</p>
                                <Select
                                    onChange={this.handleUpdate('address_code_type')}
                                    style={{ width: '100%' }}
                                    value={this.state.updatedAddress.address_code_type === 'LIMS' ? 0 : null}
                                >
                                    <MenuItem value={-1} key={-1}></MenuItem>
                                    {this.returnTypeCode()}
                                </Select>
                            </Grid>

                            {this.state.updatedAddress.address_code_type ? (
                                <Grid item xs={12} style={{ padding: 4 }}>
                                    <TextField
                                        id="code"
                                        label="code"
                                        margin="normal"
                                        style={{ width: '100%' }}
                                        value={this.state.updatedAddress.address_code}
                                        onChange={this.handleUpdate('address_code')}
                                    />
                                </Grid>
                            ) : (
                                <></>
                            )}

                            <Grid item xs={12} style={{ padding: 4 }}>
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.updatedAddress.default_flag} />}
                                    label="Default"
                                    labelPlacement="end"
                                    onChange={this.handleUpdate('default_flag', (target) => target.checked)}
                                />
                            </Grid>
                        </Modal>
                    </>
                )}
            </div>
        );
    }
}

AddressList.propTypes = {};

const mapStateToProps = (state) => ({
    res: state.res,
});

const mapDispatchToProps = (dispatch) => ({
    showSnackbar: (msg, variant, queue = false) => dispatch(easySnackbar(msg, variant, queue)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddressList));
